import React from "react";
import { Target, CheckCircle2, Lock, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CurrentMissionCard({ mission, stage, mode, onOpenMission }) {
  const isCompleted = mission?.is_completed || false;
  const currentCount = mission?.current_count ?? 0;
  const targetCount = mission?.target_count ?? 1;
  const progressPercent = Math.min(100, Math.round((currentCount / targetCount) * 100));

  const getStageDisplay = () => {
    if (mode === "MODO_CAVERNA") {
      const map = {
        CAVE_PROFILE: "Modo Caverna → Perfil Facebook",
        CAVE_PAGE: "Modo Caverna → Página Facebook",
        CAVE_WHATSAPP: "Modo Caverna → WhatsApp Business",
        CAVE_ZAPDATA: "Modo Caverna → ZapData",
        CAVE_CREATIVE: "Modo Caverna → Criativos",
        CAVE_UNLOCK: "Modo Caverna → Desbloqueio",
      };
      return map[stage] || "Modo Caverna";
    }
    const map = {
      LIVE_PRETEST: "Modo Live → Pré-Teste",
      LIVE_TEST: "Modo Live → Teste",
      LIVE_PRESCALE: "Modo Live → Pré-Escala",
      LIVE_SCALE: "Modo Live → Escala",
    };
    return map[stage] || "Modo Live";
  };

  return (
    <div
      data-testid="current-mission-card"
      className="bg-[#14161C] border border-[#282D3D] rounded-xl p-4 shadow-md flex flex-col justify-between"
    >
      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-1.5 text-xs text-[#FF6B00] font-bold">
            <Target className="w-4 h-4" />
            <span data-testid="current-stage-breadcrumb">{getStageDisplay()}</span>
          </div>
          <span className="text-[11px] font-medium text-gray-400">Sua Missão Agora</span>
        </div>

        <h3 data-testid="mission-title" className="text-base font-bold text-white mb-1">
          {mission?.title || "Concluir Etapa Atual"}
        </h3>
        <p className="text-xs text-gray-300 line-clamp-2 mb-3">
          {mission?.description || "Execute o objetivo chave da fase para liberar o próximo nível."}
        </p>
      </div>

      <div>
        {targetCount > 1 && (
          <div className="mb-3">
            <div className="flex justify-between text-[11px] text-gray-400 mb-1">
              <span>Progresso</span>
              <span className="font-bold text-white">
                {currentCount} / {targetCount} {mission?.unit || ""}
              </span>
            </div>
            <div className="w-full h-2 bg-[#1E2330] rounded-full overflow-hidden">
              <div
                className="h-full bg-[#FF6B00] rounded-full transition-all duration-500"
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          </div>
        )}

        <div className="flex items-center justify-between pt-2 border-t border-[#232733]">
          <span className="text-[11px] text-gray-400 flex items-center gap-1">
            {isCompleted ? (
              <span className="text-emerald-400 flex items-center gap-1 font-semibold">
                <CheckCircle2 className="w-3.5 h-3.5" /> Concluída
              </span>
            ) : (
              <span className="text-yellow-400 flex items-center gap-1 font-semibold">
                Em Andamento
              </span>
            )}
          </span>

          <Link
            to="/missoes"
            data-testid="open-mission-btn"
            className="inline-flex items-center gap-1 text-xs font-bold text-[#FF6B00] hover:text-[#FF8533] transition-colors"
          >
            <span>ABRIR MISSÃO</span>
            <ChevronRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
